import React, { useState, useEffect } from 'react';

export default function CookieConsent() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie-consent');
    if (!consent) {
      setShow(true);
    }
  }, []);

  const accept = () => {
    localStorage.setItem('cookie-consent', 'true');
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[100] bg-white/90 dark:bg-slate-900/90 backdrop-blur-md border-t border-sky-200/50 dark:border-slate-800 p-4 shadow-2xl">
      <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-sm text-stone-600 dark:text-stone-300">
          We use cookies to ensure you get the best experience and to serve relevant ads (Google AdSense). By continuing to use FreeTooly, you consent to our use of cookies as described in our <a href="/privacy" className="text-brand-600 dark:text-brand-400 font-medium hover:underline">Privacy Policy</a>.
        </p>
        <button 
          onClick={accept} 
          className="btn-primary text-sm whitespace-nowrap interactive-tap px-6"
        >
          Got it
        </button>
      </div>
    </div>
  );
}
